// extracted by mini-css-extract-plugin
export default {"main_sec":"styles_main_sec__uDA7h","tabContent":"styles_tabContent__VaXYb","button":"styles_button__GlQtH"};